import { DAOButton } from "components/button";
import dayjs from "dayjs";
import { CustomerInterface } from "interfaces";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { api, ui, utils } from "services";

export const CardComponent = ({
  titleIcon,
  title,
  sharedRevenue,
  apr,
  balance,
  totalBalance,
  unstakeFn,
  stakeFn,
  claimFn,
  restakeFn,
  totalReward,
  borderColor,
  contentColor,
  rewardValue,
  isUsdt
}: {
  titleIcon?: string,
  title?: string,
  sharedRevenue?: string | number,
  apr?: string,
  balance?: string | number,
  totalBalance?: string | number,
  unstakeFn?: any,
  stakeFn?: any,
  claimFn?: any,
  restakeFn?: any,
  totalReward?: any,
  borderColor: string,
  contentColor: string,
  rewardValue?: number,
  isUsdt?: boolean
}) => {
  const user = useSelector((state: RootState) => state.user);
  const [loadingRestake, setLoadingRestake] = useState(false);
  const [loadingClaim, setLoadingClaim] = useState(false);

  const checkIAPLock = async () => {
    let usdt = user?.[CustomerInterface.usdt_guaranteed] ?? 0;
    let rs = await api.post("/dao/get-usdt-guarantee", {})
    let dif = Number(usdt) - Number(rs);
    if (dif < 0) {
      return Math.abs(dif)
    }
    return 0;
  }

  return (
    <div className="w-full flex gap-4 flex-col lg:flex-row font-cookie mt-4 xl:mt-0">
      <div className={`w-full pb-2 rounded-xl`}
        style={{
          background: borderColor
        }}
      >
        <div className={`rounded-lg mx-1 mt-1 px-5`}
          style={{
            background: contentColor
          }}
        >
          <div className="flex gap-2 py-6 pb-8">
            <img
              src={titleIcon}
              alt="mstr"
              className="inline-block mr-2 h-10 w-auto mt-1"
            />
            <div className="text-white self-center font-bold text-lg">
              {title}
            </div>
          </div>

          {!isUsdt && <div className="flex flex-row gap-4 justify-between pb-8">
            <div>
              <div className="text-[#A2A1A4]">Shared Revenue</div>
              <div className="text-white text-lg md:text-2xl mt-1">{sharedRevenue}</div>
            </div>
            {apr && <div>
              <div className="text-[#A2A1A4]">APR</div>
              <div className="text-white text-lg md:text-2xl mt-1">
                {apr}
              </div>
            </div>}
            <div>
              <div className="text-[#A2A1A4]">My stake/Total stake</div>
              <div className="text-white text-lg md:text-2xl mt-1">
                {balance} / {totalBalance}
              </div>
            </div>
          </div>}

          {isUsdt &&
            <div className="flex flex-row gap-4 justify-between pb-8">
              <div>
                <div className="text-[#A2A1A4]">USDT Guaranteed / USDT Guarantee Required</div>
                <div className="text-white text-lg md:text-2xl mt-1">
                  <span className={`${balance < totalBalance ? "text-red" : "text-green"}`}>{balance} / {totalBalance}</span>
                </div>
              </div>
              <div>
                <div className="text-[#A2A1A4]">IAP Mode Until</div>
                <div className="text-white text-lg md:text-2xl mt-1">
                  {user?.[CustomerInterface.iap_lock_util]
                    && dayjs().isBefore(user?.[CustomerInterface.iap_lock_util])
                    && dayjs(user?.[CustomerInterface.iap_lock_util]).format("DD/MM/YYYY HH:mm:ss")
                  }
                </div>
              </div>
            </div>
          }

          <div className="flex gap-4 pb-4 justify-end">
            <div className="w-[120px]">
              <DAOButton
                disabled={!user || !sessionStorage.getItem("token")}
                icon="unstake-icon.png" theme="light" color="white"
                onClick={async () => {
                  let isIAPLock = await checkIAPLock();
                  if (isIAPLock) {
                    ui.openIAPNoti(isIAPLock)
                  } else {
                    await unstakeFn();
                  }
                }}
              >Unstake</DAOButton>
            </div>
            {/* <div className="w-[120px]">
              <DAOButton
                disabled={!user || !sessionStorage.getItem("token")}
                icon="add-icon.png" theme="light" color="yellow"
                onClick={stakeFn}>Add more</DAOButton>
            </div> */}
          </div>
        </div>

        {isUsdt &&
          <div className="px-5 py-2 pt-5 block md:flex md:justify-between">
            <div className="w-full text-white flex md:block w-full justify-between mb-4 md:mb-0">
              <div className="text-sm font-normal mb-1">
                Total Withdrawable USDT:
              </div>
              <div className="">
                <div className="font-medium text-lg md:text-2xl">
                  {utils.convertToInternationalCurrencySystem(
                    Math.max((Number(balance) - Number(totalBalance)), 0),
                    8
                  )}
                  {" "} USDT
                </div>
              </div>
            </div>
          </div>
        }

        {!isUsdt && <div className="px-5 py-2 pt-5 block md:flex md:justify-between">
          <div className="w-full text-white flex md:block w-full justify-between mb-4 md:mb-0">
            <div className="text-sm font-normal mb-1">
              Your Total Reward:
            </div>
            <div className="">
              {totalReward}
            </div>
          </div>
          <div className="flex gap-4 justify-end self-center">
            <div className="w-[120px]">
              <DAOButton
                loading={loadingRestake}
                disabled={!user || !sessionStorage.getItem("token") || !Number(rewardValue ?? 0)}
                icon="restake-icon.png" theme="dark" color="yellow"
                onClick={
                  async () => {
                    if (restakeFn) {
                      setLoadingRestake(true);
                      await restakeFn();
                      setLoadingRestake(false);
                    }
                  }
                }>Restake</DAOButton>
            </div>
            <div className="w-[100px]">
              <DAOButton
                loading={loadingClaim}
                disabled={!user || !sessionStorage.getItem("token") || !Number(rewardValue ?? 0)}
                icon="claim-icon.png" theme="dark" color="white" onClick={
                  async () => {
                    if (claimFn) {
                      setLoadingClaim(true);
                      await claimFn();
                      setLoadingClaim(false);
                    }
                  }
                }>Claim</DAOButton>
            </div>
          </div>
        </div>}
      </div>
    </div>
  )
}